module.exports = __webpack_public_path__ + "img/yt.2bc3a45a.svg";